import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@appEnvironments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { lastValueFrom, map, tap } from 'rxjs';

@Component({
    selector: 'app-not-service-available',
    templateUrl: './not-service-available.component.html',
    styleUrls: ['./not-service-available.component.scss']
})
export class NotServiceAvailableComponent implements OnInit, OnDestroy {
    readonly tiempoInicial = 30;
    tiempoRestante = this.tiempoInicial;

    isLoading = false;
    private intervalId?: ReturnType<typeof setInterval>;

    private readonly urlCheckSincro = `${environment.baseUrl}/gateway/sincro/health`;

    constructor(
        private http: HttpClient,
        private router: Router,
        private location: Location
    ) {}

    ngOnInit(): void {
        this.iniciarContador();
    }

    ngOnDestroy(): void {
        this.detenerContador();
    }

    private actualizarContador(): void {
        if (this.tiempoRestante > 0) {
            this.tiempoRestante--;
            return;
        }

        this.onRetry();
    }

    iniciarContador(): void {
        this.detenerContador();
        this.tiempoRestante = this.tiempoInicial;

        this.intervalId = setInterval(() => this.actualizarContador(), 1000);
    }

    detenerContador(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    }

    private async checkSincro(): Promise<boolean> {
        try {
            const res = await lastValueFrom(this.http.get<boolean>(this.urlCheckSincro));
            return !!res;
        } catch (error) {
            return false;
        }
    }

    async onRetry(): Promise<void> {
        this.isLoading = true;
        this.detenerContador();

        const isSincroActive = await this.checkSincro();

        if (isSincroActive) {
            this.isLoading = false;

            if (window.history.length > 2) {
                this.location.back();
            } else {
                this.router.navigateByUrl('/');
            }

            return;
        }

        this.iniciarContador();
        this.isLoading = false;
    }
}
